/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */

import { RemoteDataActions } from 'plugin/liferay-widgets-react-web';
import { ClassNames } from '../constants/Constants';

const className = ClassNames.NamedProp;

const api = 'NamedPropWebApi';
const listApiMethod = 'loadNamedPropsFromService';

export default {

    list: (query) => RemoteDataActions.list('namedprops', className, query, api + '.' + listApiMethod)

};



// WEBPACK FOOTER //
// ./js/actions/NamedPropsActions.js